<!-- About us Start -->
<section class="section why-choose-us" id="about" style="background: #FAF5FF; background-size: cover;">
  <div class="" style="width: 100%; display:flex;justify-content:center;">
    <!-- <div class="absolute">
      <img src="/assets/images/transition-pattern.png" class="img-responsive relative" />
    </div> -->
  </div>

  <div class="container">
    <div class="row justify-content-center">

      <div class="col-lg-12">
        <div class="title text-center mb-5">
          <h1 class="mb-5">Corporate Awards & Recognition</h1>
          <div class="container">
            <div class="row">
              <div class="col-lg-3 text-left justify-content-center align-self-center">
                <p class="awards-indicator">Awards</p>
                <div style="border-bottom: 1px solid #575757;width:100%"></div>
              </div>
              <div class="col-lg-9">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="card card-details-white text-left pt-4 pb-5">
                      <div class="row">
                        <div class="col-lg-12 icon-holder center">
                          <div>
                            <div>
                              <img src="../../../assets/images/winner.png" height="50" />
                            </div>
                            <div class="mt-3">
                              <p class="winner-text">Winner</p>
                              <div class="winner-text-border"></div>
                            </div>
                            <div>
                              <p class="award-title">Digital Impact Award</p>
                              <p class="award-title">2020</p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="card card-details-white text-left pt-4 pb-4">
                      <div class="row">
                        <div class="col-lg-12 icon-holder center">
                          <div class="job-card">
                            <div class="job-card-header">
                              <img src="../../../assets/images/winner.png" height="50" />
                            </div>
                            <div class="mt-3">
                              <p class="winner-text">Winner</p>
                              <div class="winner-text-border"></div>
                            </div>
                            <div>
                              <p class="award-title" style="line-height:20px !important">Ecowas Best Small
                                Business Award</p>
                              <p class="award-title">2021</p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="card card-details-white text-left pt-4 pb-4">
                      <div class="row">
                        <div class="col-lg-12 icon-holder center">
                          <div class="job-card">
                            <div class="job-card-header">
                              <img src="../../../assets/images/winner.png" height="50" />
                            </div>
                            <div class="mt-3">
                              <p class="winner-text">Winner</p>
                              <div class="winner-text-border"></div>
                            </div>
                            <div>
                              <p class="award-title" style="line-height:20px !important">Consultancy of <br />
                                the Year</p>
                              <p class="award-title">2021</p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-lg-3 text-left justify-content-center align-self-center">
                <p class="awards-indicator">Recognition</p>
                <div style="border-bottom: 1px solid #575757;width:100%"></div>
              </div>

              <div class="col-lg-9">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="card card-details-white text-left pt-5 pb-4">
                      <div class="row">
                        <div class="col-lg-12 icon-holder center">
                          <div class="job-card">
                            <div class="mb-4">
                              <img src="../../../assets/images/diamonds.png" height="50" />
                            </div>

                            <div>
                              <p class="recognition-text">The Moore
                                Foundation</p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="card card-details-white text-left pt-5 pb-5">
                      <div class="row">
                        <div class="col-lg-12 icon-holder center">
                          <div class="job-card">
                            <div class="mb-4">
                              <img src="../../../assets/images/diamonds.png" height="50" />
                            </div>

                            <div>
                              <p class="recognition-text">iHope</p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="card card-details-white text-left pt-5 pb-5">
                      <div class="row">
                        <div class="col-lg-12 icon-holder center">
                          <div class="job-card">
                            <div class="mb-4">
                              <img src="../../../assets/images/diamonds.png" height="50" />
                            </div>

                            <div>
                              <p class="recognition-text">ATFAC</p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- About us End -->
